import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ClearIcon, SearchIcon } from '../../assets/icons';

export interface SearchBarProps {
  inputValue: string;
  setInputValue: (inputValue: string) => void;
}

export function SearchBar({ inputValue, setInputValue }: Readonly<SearchBarProps>): React.ReactElement<SearchBarProps> {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <OutlinedInput
      className="mx-5 mt-5 h-10 md:my-2 md:mr-2 lg:my-0"
      value={inputValue}
      onChange={(event) => setInputValue(event.target.value)}
      onClick={(event) => event.stopPropagation()}
      placeholder={t('SHARED_SEARCH_PLACEHOLDER')}
      startAdornment={
        <InputAdornment position="start">
          <SearchIcon />
        </InputAdornment>
      }
      endAdornment={
        <InputAdornment position="end">
          {inputValue && (
            <ClearIcon
              aria-label={t('SHARED_CLEAR')}
              className="cursor-pointer"
              onClick={() => {
                setInputValue('');
                inputRef.current?.focus();
              }}
            />
          )}
        </InputAdornment>
      }
      inputRef={inputRef}
      inputProps={{ role: 'searchbox' }}
    />
  );
}
